import Page from '../../classes/Page';
import { homeAnimations } from './homeAnimations';

const homePage = new Page({
  name: 'home',
  rootElementId: 'js-page-home',
  // onCreate() {
  //   console.log('homePage create')
  // },
  onInit() {
    // console.log('homePage init')

    this
      .addComponent(homeAnimations)
  },
  // onDestroy() {
  //   console.log('homePage destroy')
  // },
});

export default homePage;
